import { render, staticRenderFns } from "./TimeStep.vue?vue&type=template&id=b4c5dd7e&scoped=true"
import script from "./TimeStep.vue?vue&type=script&lang=ts"
export * from "./TimeStep.vue?vue&type=script&lang=ts"
import style0 from "./TimeStep.vue?vue&type=style&index=0&id=b4c5dd7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c5dd7e",
  null
  
)

export default component.exports